import {isRatingListKey, ReviewsStatisticDataType} from '../../../../../service/reviews/reviews-statistic';

export function getRatingListCountForKey(
    ratingList: ReviewsStatisticDataType['ratingList'] | undefined,
    rating: unknown
): number {
    return isRatingListKey(rating) ? ratingList?.[rating] ?? 0 : 0;
}
